// The api sends from this address unless the signed-in account's own
// @jobbiz.fr address is picked; it refuses any other (INVALID_SENDER_EMAIL).
export const CRM_DEFAULT_SENDER = 'rh@jobbiz.fr';

// The addresses the e-mail may leave from, the default first: the account's
// own one when it is a @jobbiz.fr address, then rh@jobbiz.fr.
export const senderOptionsOf = (accountEmail) => {
  const own = accountEmail?.trim().toLowerCase();
  return own && own.endsWith('@jobbiz.fr') && own !== CRM_DEFAULT_SENDER ? [own, CRM_DEFAULT_SENDER] : [CRM_DEFAULT_SENDER];
};

/**
 * The « De » line of MailComposer. With a single address it stays shown,
 * disabled, so that the sender is never a guess.
 */
const SenderField = ({ label, options, value, onChange }) => (
  <div className="flex min-h-[44px] items-center gap-2 border-b border-gray-100 px-4 py-1.5">
    <span className="shrink-0 text-sm text-gray-500">{label}</span>
    <select
      aria-label={label}
      value={value}
      disabled={options.length < 2}
      onChange={(event) => onChange(event.target.value)}
      className="min-w-0 flex-1 border-0 bg-transparent py-1 pl-0 text-sm text-gray-900 focus:outline-none focus:ring-0 disabled:cursor-default disabled:text-gray-700"
    >
      {options.map((address) => (
        <option key={address} value={address}>
          {address}
        </option>
      ))}
    </select>
  </div>
);

export default SenderField;
